import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/dashboard"
const options = {role: ROLE.RESTAURANT};

export const dashboardApi = async (values) => {
    return await axiosInstance(options).get(`${path}/dashboard`,values);
}


